
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/inspiration/category/[category]",
      function () {
        return require("private-next-pages/en/inspiration/category/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/inspiration/category/[category]"])
      });
    }
  